export const LINK_TYPE = {
  LINK: 'Link',
  TELEFON_PRIVAT: 'Private Telefonnummer',
  TELEFON_ARBEIT: 'Geschäftliche Telefonnummer',
  TELEFON: 'Telefon',
  EMAIL_PRIVAT: 'Private E-Mail',
  EMAIL_ARBEIT: 'Geschäftliche E-Mail',
  EMAIL: 'Email',
  GEBURTSTAG: 'Geburtstag',
  NOTIZEN: 'Notizen',
  ADRESSE: 'Adresse',
  ADRESSE_PRIVAT: 'Privatadresse',
  ADRESSE_FIRMA: 'Firmenadresse',
  SOCIAL_MEDIA: 'Social Media',
};

export const USER_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  BLOCKED: 'blocked',
};

export const CARD_STATUS = {
  ORDERED: 'ordered',
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  DEMO: 'demo',
  UNCLAIMED: 'unclaimed',
};

export const ORDER_STATUS = {
  AUSSTEHEND: 'Ausstehend',
  FEHLGESCHLAGEN: 'Fehlgeschlagen',
  BEZAHLT: 'Bezahlt',
  GELIEFERT: 'Geliefert',
  ABGEBROCHEN: 'Abgebrochen',
};

// Jede Firmenbestellung erzeugt sofort Rechnung, Produktionsmail und Karten,
// bevor bezahlt ist. Mehr offene Bestellungen pro Firma lehnt der Server ab
// (der Plattform-Admin ist ausgenommen).
export const MAX_OPEN_COMPANY_ORDERS = 10;

// Plattform-Rollen (user vs admin)
export const USER_ROLE = {
  USER: 'user',
  GLOBAL_ADMIN: 'admin',
};

// Firmen-Rollen (separates Feld companyRole auf dem User)
export const COMPANY_ROLES = {
  MEMBER: 'member',
  COMPANY_ADMIN: 'companyAdmin',
};

export const COMPANY_STATUS = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  TRIALING: 'trialing',
  UNPAID: 'unpaid',
  // Erste Zahlung noch nicht abgeschlossen (Setup abgebrochen/fehlgeschlagen).
  // Muss im Enum stehen, sonst schlägt company.save() nach dem Anlegen der
  // Stripe-Subscription mit einem Validation-Error fehl.
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
};

// Status, bei denen eine Firma als "hat ein laufendes Business-Abo" gilt.
// past_due zählt bewusst dazu: die Zahlung ist offen, das Abo läuft aber noch
// (reconcileSubscriptions suspendiert erst nach Ablauf der Grace Period, danach
// steht der Status auf canceled). Massgeblich dafür, ob der Firmenname eines
// Users vorgegeben ist oder frei bearbeitet werden darf.
//
// incomplete zählt ebenfalls dazu, weil es der Übergangsstatus zwischen "Abo
// starten" geklickt und Zahlung bestätigt ist: eine Firma aus der Testphase
// verlöre sonst genau während des Bezahlvorgangs ihre Freischaltung. Stripe
// setzt incomplete nach ~23h selbst auf incomplete_expired, worauf die Grace
// Period greift — der Status kann also nicht dauerhaft Zugriff gewähren.
export const ACTIVE_SUBSCRIPTION_STATUSES = [
  SUBSCRIPTION_STATUS.ACTIVE,
  SUBSCRIPTION_STATUS.TRIALING,
  SUBSCRIPTION_STATUS.PAST_DUE,
  SUBSCRIPTION_STATUS.INCOMPLETE,
];

export const hasActiveSubscription = (company) =>
  !!company &&
  ACTIVE_SUBSCRIPTION_STATUSES.includes(company.subscriptionStatus);

// Status, die ein beendetes Abo bezeichnen — Startpunkt der Grace Period in
// scripts/reconcileSubscriptions.js.
export const ENDED_SUBSCRIPTION_STATUSES = [
  SUBSCRIPTION_STATUS.CANCELED,
  SUBSCRIPTION_STATUS.UNPAID,
  SUBSCRIPTION_STATUS.INCOMPLETE_EXPIRED,
];

// Stripe-Status → interner Status. Eine gemeinsame Abbildung für Webhook und
// Reconcile-Job, damit die beiden Schreibpfade nicht auseinanderlaufen.
// `paused` wird bewusst auf null abgebildet: der Status wird nicht verwendet
// und soll keinen Zugriff gewähren.
export const mapStripeSubscriptionStatus = (stripeStatus) => {
  const mapping = {
    active: SUBSCRIPTION_STATUS.ACTIVE,
    past_due: SUBSCRIPTION_STATUS.PAST_DUE,
    canceled: SUBSCRIPTION_STATUS.CANCELED,
    trialing: SUBSCRIPTION_STATUS.TRIALING,
    unpaid: SUBSCRIPTION_STATUS.UNPAID,
    // incomplete sichtbar machen: das Frontend bietet dem CompanyAdmin dann
    // "Zahlung abschliessen" an, statt einen leeren Status zu zeigen.
    incomplete: SUBSCRIPTION_STATUS.INCOMPLETE,
    incomplete_expired: SUBSCRIPTION_STATUS.INCOMPLETE_EXPIRED,
    paused: null,
  };
  return mapping[stripeStatus] || null;
};

// sVisit Business hat genau einen Tarif: ein gestaffelter Preis pro User,
// wahlweise monatlich oder jährlich abgerechnet. Beide Preise hängen am Produkt
// aus lib/stripe/config.js (STRIPE_BUSINESS_PRODUCT_ID_TEST/_LIVE, atomar mit
// dem Key desselben Modus aufgelöst) und werden von utils/businessPricing.js
// direkt aus Stripe gelesen — die Beträge stehen bewusst nirgends im Code. Ein
// Stufen-Enum (früher
// COMPANY_SUBSCRIPTION_TYPE mit Basic/Professional/Enterprise) gibt es bewusst
// nicht mehr — es wurde nie ausgewertet und der Preis hing nie daran.

// Zugehörigkeit zu einer Firma, KEIN Entitlement. accountType sagt nichts
// darüber aus, welche Funktionen jemand nutzen darf — dafür ist der
// Abo-Status der Firma (bzw. später ein individueller Plan) massgeblich.
export const ACCOUNT_TYPE = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
};
